
import React from "react";
import { Site } from "@/services/types";
import SitesList from "./SitesList";

interface SitesListWrapperProps {
  isDeptPage: boolean;
  deptName: string;
  filteredSites: Site[];
  isLoading: boolean;
}

const SitesListWrapper: React.FC<SitesListWrapperProps> = ({
  isDeptPage,
  deptName,
  filteredSites,
  isLoading
}) => {
  return (
    <section className="mb-20" aria-labelledby="sites-list-heading">
      <div className="text-center mb-10">
        <h2 id="sites-list-heading" className="text-3xl md:text-4xl font-heading font-bold mb-6 text-fabre-gray">
          {isDeptPage ? `Nos centres dans ${deptName}` : "Tous nos centres de recyclage"}
        </h2>
        <div className="w-24 h-1 bg-fabre-green mx-auto mb-6"></div>
        <p className="text-lg text-fabre-darkteal max-w-3xl mx-auto">
          {isDeptPage 
            ? `${filteredSites.length} centre(s) spécialisé(s) dans la gestion des déchets à votre service dans ${deptName}.`
            : `${filteredSites.length} centres équipés pour tous vos besoins en recyclage, achat de métaux et location de bennes.`
          }
        </p>
      </div>
      <div className="bg-gradient-to-br from-white to-fabre-green/20 rounded-3xl shadow-xl border border-fabre-green/20 p-8">
        <SitesList sites={filteredSites} loading={isLoading} />
      </div>
    </section>
  );
};

export default SitesListWrapper;
